import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Topbar from "./componets/Topbar/Topbar";
import AccountNotices from "./componets/AccountNotices/AccountNotices";
import { accountNoticeState, unavailableAccountNotice } from "./componets/AccountNotices/accountNoticeState";
import PlaceAbsence from "./componets/Course/PlaceAbsence/PlaceAbsence";
import AbsenceOverview from "./componets/Course/AbsenceOverview/AbsenceOverview";
import { supportContext, supportRequest, endSupport } from "./supportBoot";
const buttonStyle = {background:"#18586a", color:"#fff", border:"1px solid #72b3c2", borderRadius:6, padding:"10px 14px"};

export default function SupportApp() {
  const [page, setPage] = useState("status");
  const [status, setStatus] = useState(null);
  const [expired, setExpired] = useState(false);
  const context = supportContext();
  useEffect(() => {
    let stopped = false;
    const check = async () => {
      try {
        const response = await supportRequest("getStudentAccountStatus");
        if (!stopped) setStatus(accountNoticeState(response.data));
      } catch (_) { if (!stopped) setStatus(unavailableAccountNotice(null)); }
    };
    check();
    const timer = setInterval(() => {
      if (Date.now() >= context.expires_at * 1000) {
        clearInterval(timer);
        setExpired(true); endSupport(false);
      }
    }, 1000);
    const denied = () => setExpired(true);
    window.addEventListener("sp-support-expired", denied);
    return () => { stopped = true; clearInterval(timer); window.removeEventListener("sp-support-expired", denied); };
  }, [context.expires_at]);
  if (expired) return <main style={{padding:32}}><h1>Prüfzugang beendet</h1><p>Bitte erneut über das Schülerprofil öffnen.</p><a href={`https://www.backend.salsaworldstandardclass.com/de/student-info/${context.student_id}`}>Zurück zum Schülerprofil</a></main>;
  return <BrowserRouter>
    <Topbar toogle={false} setToogle={() => {}} qrSannerTrue={() => {}} accountStatus={status} />
    <main style={{padding:"110px 20px 30px", maxWidth:1100, margin:"0 auto"}}>
      <section style={{padding:16, border:"2px solid #72b3c2", borderRadius:8, background:"#26343d", color:"#fff", marginBottom:20}}>
        <h1 style={{fontSize:24}}>App-Prüfansicht: {context.name}</h1>
        <p>Nur ansehen · Änderungen und Nachrichten sind gesperrt · gültig bis {new Date(context.expires_at*1000).toLocaleTimeString("de-CH", {hour:"2-digit", minute:"2-digit"})}</p>
        <button type="button" style={buttonStyle} onClick={() => endSupport(true)}>Prüfansicht beenden</button>
      </section>
      <nav aria-label="App prüfen" style={{display:"flex", gap:10, flexWrap:"wrap", marginBottom:20}}>
        <button type="button" style={buttonStyle} onClick={() => setPage("status")}>Ampel und Abo</button>
        <button type="button" style={buttonStyle} onClick={() => setPage("absence")}>Absenzformular prüfen</button>
        <button type="button" style={buttonStyle} onClick={() => setPage("overview")}>Absenzen ansehen</button>
      </nav>
      <AccountNotices status={status} language="de" />
      {page === "status" && <p>Die Ampel oben und die Hinweise stammen aus derselben Kontoprüfung wie in der Schüler-App. Es werden keine Zahlungen oder Abos verändert.</p>}
      {page === "absence" && <><p>Originales App-Formular. Kurse und Datumsfelder können geprüft werden. „Speichern“ führt hier keine Absenz aus.</p><PlaceAbsence /></>}
      {page === "overview" && <AbsenceOverview />}
    </main>
  </BrowserRouter>;
}
